import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import ProjectDetailsOverview from '@features/project-management-tools/components/ProjectDetailsOverview';
import ProjectDetailsTopbar from '@features/project-management-tools/components/ProjectDetailsTopbar';
import ProjectDetailsTaskSection from '@features/project-management-tools/components/ProjectDetailsTaskSection';
import { useGetProjectByIdQuery } from '@features/project-management-tools/api/projectManagementApi';
import { MIX_PANEL_EVENTS } from '@features/project-management-tools/constents';

import { useMixPanelTrakingEventMutation } from '@/api/commonApis';

const MyProjectDetailsPage = () => {
	const { id } = useParams();
	const { data: projectDetails, refetch } = useGetProjectByIdQuery(id);
	const [mixPanelTrakingEvent] = useMixPanelTrakingEventMutation();

	useEffect(() => {
		mixPanelTrakingEvent({ type: MIX_PANEL_EVENTS.PROJECT_DETAILS_VIEW, body: { projectId: id } });
	}, []);

	useEffect(() => {
		refetch();
	}, [id]);

	return (
		<>
			<ProjectDetailsTopbar projectDetails={projectDetails} />
			<div className="body-content task-content bg-white">
				<div className="porject-details-container">
					<ProjectDetailsOverview
						projectDetails={projectDetails}
						refetch={refetch}
						projectId={id}
					/>
					<ProjectDetailsTaskSection
						refetchProjectDetails={refetch}
						projectDetails={projectDetails}
					/>
				</div>
			</div>
		</>
	);
};

export default MyProjectDetailsPage;
